import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class ECService {
  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;


  obtenerEntradasMercancia(num_pedido, proveedor): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('entradas', num_pedido)
      .set('tipo_op', 'X')
      .set('wo_em', '')
     .set('proveedor', proveedor)
    };
     return this.http.get(this.basePath +
     'orden-compra/entradas', options);
  }

  guardarFacturaOC(identificadorDeLlamada, fd, cfdi): Observable<any> {
    const params = fd;
    const checkCFDI = cfdi;
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'Proveedores-facturas/guardarFacturaOC' + identificadorDeLlamada +
     '&sinCfdi=' + checkCFDI, params, options);
  }

  enviarFactura(formData): Observable<any> {
    const params = formData;
    // tslint:disable-next-line:max-line-length
    const httpHeaders = new HttpHeaders().set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath + 'orden-compra/carga-extra-costos', params, options);
  }



}



// WEBPACK FOOTER //
// ./src/app/services/invoices-ec/ec.service.ts